import React from 'react';
import { XIcon } from 'lucide-react';
export function FailedMethodsSection() {
  const methods = [{
    title: 'Agendas Tradicionales',
    desc: 'Te piden un orden que tu cerebro simplemente no puede procesar bajo presión.'
  }, {
    title: 'El Método Pomodoro',
    desc: 'Te irrita porque interrumpe tu flujo justo cuando finalmente lograste conectar.'
  }, {
    title: 'Listas de Tareas Infinitas',
    desc: 'Solo sirven como un recordatorio visual de todo lo que te hace sentir culpable.'
  }, {
    title: "Intentar 'Meditar'",
    desc: 'Para calmarte es como tratar de frenar un tren bala con las manos desnudas.'
  }];
  return <section className="py-20 relative border-y border-white/5 bg-black/20" data-id="element-12">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-50 mb-4" data-id="element-15">
            Por qué lo que has intentado no funciona
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-16">
            Las herramientas de productividad tradicionales fueron diseñadas
            para cerebros neurotípicos que no luchan contra el ruido constante.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-17">
          {methods.map((method, index) => <div key={index} className="bg-white/5 border border-white/10 rounded-2xl p-6 flex items-start gap-4 hover:bg-white/[0.07] transition-colors" data-id="element-18">
              <div className="mt-1 bg-red-500/20 border border-red-500/30 rounded-full p-1.5 flex-shrink-0" data-id="element-19">
                <XIcon className="w-4 h-4 text-red-400" data-id="element-20" />
              </div>
              <div data-id="element-21">
                <h3 className="text-lg font-semibold text-slate-200 mb-2" data-id="element-22">
                  {method.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-23">{method.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}